"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitForResponse = exports.runTaskAndWaitForResponse = exports.requestAndWaitForResponse = exports.delayItBy = exports.PromiseQueue = void 0;
var _globalStates = require("../globalstates/globalStates");
var _messageRegistery = require("./messageRegistery");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_TIMEOUT = 60000;
var requestAndWaitForResponse = exports.requestAndWaitForResponse = function requestAndWaitForResponse(request, payload, response, check, name, timeout) {
  return new Promise(function (resolve, reject) {
    var isResolved = false;
    var registration = (0, _messageRegistery.registerMsgHandler)(response, function (payload) {
      var data = JSON.parse(payload);
      var result = check(data);
      if (result) {
        (0, _messageRegistery.unregisterMsgHandler)(response, registration);
        isResolved = true;
        clearTimeout(timer);
        console.debug("MsgQueue: ".concat(name, " success"));
        resolve(data);
      }
    });
    var timer = setTimeout(function () {
      if (!isResolved) {
        console.error("MsgQueue: timeout for ".concat(name), response);
        resolve(new Error("timeout"));
      }
      (0, _messageRegistery.unregisterMsgHandler)(response, registration);
    }, timeout || DEFAULT_TIMEOUT);
    console.debug("MsgQueue: executing ".concat(name), request);
    (0, _globalStates.getGlobalStates)().eventBus.sendMsg(request, payload);
  });
};
var runTaskAndWaitForResponse = exports.runTaskAndWaitForResponse = function runTaskAndWaitForResponse(task, response, check, name, timeout) {
  return new Promise(function (resolve, reject) {
    var isResolved = false;
    var registration = (0, _messageRegistery.registerMsgHandler)(response, function (payload) {
      var data = JSON.parse(payload);
      var result = check(data);
      if (result) {
        (0, _messageRegistery.unregisterMsgHandler)(response, registration);
        isResolved = true;
        clearTimeout(timer);
        console.debug("MsgQueue: ".concat(name, " success"));
        resolve(data);
      }
    });
    var timer = setTimeout(function () {
      if (!isResolved) {
        console.error("MsgQueue: timeout for ".concat(name), response);
        resolve(new Error("timeout"));
      }
      (0, _messageRegistery.unregisterMsgHandler)(response, registration);
    }, timeout || DEFAULT_TIMEOUT);
    console.debug("MsgQueue: executing ".concat(name), task);
    task();
  });
};
var waitForResponse = exports.waitForResponse = function waitForResponse(response, check, name, timeout) {
  return new Promise(function (resolve, reject) {
    var isResolved = false;
    var registration = (0, _messageRegistery.registerMsgHandler)(response, function (payload) {
      var data = JSON.parse(payload);
      var result = check(data);
      if (result) {
        (0, _messageRegistery.unregisterMsgHandler)(response, registration);
        isResolved = true;
        clearTimeout(timer);
        console.debug("MsgQueue: ".concat(name, " success"));
        resolve(data);
      }
    });
    var timer = setTimeout(function () {
      if (!isResolved) {
        console.error("MsgQueue: timeout for ".concat(name), response);
        resolve(new Error("timeout"));
      }
      (0, _messageRegistery.unregisterMsgHandler)(response, registration);
    }, timeout || DEFAULT_TIMEOUT);
    console.debug("MsgQueue: waiting for ".concat(name));
  });
};
var delayItBy = exports.delayItBy = function delayItBy(delay) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve("");
    }, delay);
  });
};
var PromiseQueue = exports.PromiseQueue = /*#__PURE__*/function () {
  function PromiseQueue() {
    _classCallCheck(this, PromiseQueue);
    this.queue = [];
    this.isProcessing = false;
  }
  return _createClass(PromiseQueue, [{
    key: "enqueue",
    value: function enqueue(task) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var queueItem = {
          task: task,
          resolve: resolve,
          reject: reject
        };
        _this.queue.push(queueItem);
        if (!_this.isProcessing) {
          _this.processQueue();
        }
      });
    }
  }, {
    key: "processQueue",
    value: function processQueue() {
      var _this2 = this;
      if (this.queue.length === 0) {
        this.isProcessing = false;
        return;
      }
      this.isProcessing = true;
      var _this$queue$shift = this.queue.shift(),
        task = _this$queue$shift.task,
        resolve = _this$queue$shift.resolve,
        reject = _this$queue$shift.reject;
      task().then(function (result) {
        resolve(result);
        _this2.processQueue();
      })["catch"](function (error) {
        reject(error);
        _this2.processQueue();
      });
    }
  }]);
}();